window.initAutoComplete = (input) ->
    if input
        options = 
        componentRestrictions: country: ['DK']
        fields: ['place_id', 'address_components', 'geometry', 'name', 'formatted_address']

        return new google.maps.places.Autocomplete(input, options)
    else
        return
